import { BetBuilder } from '@ps/isp-web-component-library/icons/BetBuilder';
import { Multiples } from '@ps/isp-web-component-library/icons/Multiples';
import type { MultipleOpportunity, SingleOpportunity } from '@ps/isp-web-services-types';

import {
  getIsSgmOpportunity,
  getIsSingleOpportunity
} from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

export const getIconNameFromOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
) => {
  if (getIsSingleOpportunity(opportunity)) {
    return getEventTypeIcon(opportunity.eventTypeId);
  }

  if (getIsSgmOpportunity(opportunity)) {
    return BetBuilder;
  }

  return Multiples;
};
